import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'

const base = `${virtualClassroomManagerRoutes.events}/details`

const routes = {
  root: base,
}

export const tabs = {
  eventEditor: `edit`,
  tasksAndResources: `tasks-and-resources`,
  schedules: `schedules`,
  waitList: `waitlist`,
}

export default routes
